// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"DetailPageSectionHeader_sectionHeader__9i7wM","asides":"DetailPageSectionHeader_asides__G7snK"};